/* Samples reorg (Oct 2026): page-wide sample icons outside the Color Samples grids.
   Used by: product cards on collection/search pages (snippets/card-samples.liquid), "Try it first" on product pages
   (snippets/samples-try-first.liquid) and the color-deck tiles (sections/samples-decks.liquid).
   Same markup and behavior as the Color Samples page (snippets/sample-ctl.liquid + assets/sample-selector.js):
   one tap = one sample in the cart (POST cart/add.js), [−] steps down (cart/change.js), icons invert while in the cart.
   Controls inside [data-sample-selector] belong to sample-selector.js and are ignored here. */
(() => {
  if (window.__sampleQuick) return; window.__sampleQuick = true;
  const routesRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const ymq = 'ymqcartopen=false'; // YMQ Cart Drawer: don't slide open on each tap
  const ours = (el) => el && el.closest('[data-sq]') && !el.closest('[data-sample-selector]');
  const ctls = () => [...document.querySelectorAll('[data-sq] [data-ss-ctl]')].filter(ours);
  let cartState = { items: [] };
  let toast, toastTimer;
  const showToast = (msg, isError) => {
    if (!toast) { toast = document.createElement('div'); toast.className = 'ss-toast sq-toast'; toast.setAttribute('role', 'status'); toast.setAttribute('aria-live', 'polite'); toast.hidden = true; document.body.appendChild(toast); }
    toast.textContent = msg; toast.classList.toggle('is-error', !!isError); toast.hidden = false;
    clearTimeout(toastTimer); toastTimer = setTimeout(() => { toast.hidden = true; }, 2600);
  };
  const label = (c) => `${c.dataset.color} ${c.dataset.kindLong || c.dataset.short}`.trim();

  const paint = (c, q) => {
    const add = c.querySelector('[data-ss-add]'); const step = c.querySelector('[data-ss-step]'); const cap = c.querySelector('.ss-ctl__cap');
    c.classList.toggle('is-added', q > 0);
    if (step) step.hidden = q === 0;
    if (cap) cap.hidden = q > 0;
    if (add && c.dataset.available !== 'false') add.setAttribute('aria-label', q > 0 ? `${c.dataset.color} ${c.dataset.short}, in cart (${q}). Add another, ${c.dataset.price}` : `Add ${c.dataset.color} ${c.dataset.short}, ${c.dataset.price}`);
    const qty = c.querySelector('[data-ss-qty]'); if (qty) qty.textContent = `×${q || 1}`;
    const dec = c.querySelector('[data-ss-dec]'); if (dec) dec.setAttribute('aria-label', `${q > 1 ? 'Remove one' : 'Remove'} ${label(c)}${q > 1 ? ` (${q} in cart)` : ' from cart'}`);
  };
  const syncFromCart = (cart) => {
    cartState = cart;
    const qty = {};
    cart.items.forEach((i) => { qty[i.variant_id] = (qty[i.variant_id] || 0) + i.quantity; });
    ctls().forEach((c) => paint(c, qty[+c.dataset.variantId] || 0));
  };
  const refreshCart = () => fetch(`${routesRoot}cart.js`, { headers: { Accept: 'application/json' } }).then((r) => r.json()).then(syncFromCart).catch(() => {});

  let queue = Promise.resolve();
  const enqueue = (job) => (queue = queue.then(job, job));
  const sectionsParam = () => {
    const drawer = document.querySelector('cart-drawer');
    let s = 'cart-icon-bubble';
    if (drawer && drawer.closest('.shopify-section')) s += ',' + drawer.closest('.shopify-section').id.replace('shopify-section-', '');
    return s;
  };
  const post = async (path, payload) => {
    const res = await fetch(`${routesRoot}${path}?${ymq}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ ...payload, sections: sectionsParam(), sections_url: window.location.pathname })
    });
    const data = await res.json();
    if (!res.ok || data.status) throw new Error(data.description || data.message || 'Could not update your cart');
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data.sections && data.sections['cart-icon-bubble']) bubble.innerHTML = data.sections['cart-icon-bubble'];
    document.dispatchEvent(new CustomEvent('dispatch:cart-drawer:refresh', { bubbles: true }));
    return data;
  };
  const same = (id) => ctls().filter((c) => +c.dataset.variantId === id);
  const busy = (els, on) => els.forEach((el) => el.classList.toggle('is-loading', on));

  const addOne = (ctl) => enqueue(async () => {
    const id = +ctl.dataset.variantId;
    const was = (cartState.items.find((i) => i.variant_id === id) || {}).quantity || 0;
    busy(same(id), true);
    try {
      await post('cart/add.js', { items: [{ id, quantity: 1 }] });
      const cart = await fetch(`${routesRoot}cart.js`).then((r) => r.json());
      const now = (cart.items.find((i) => i.variant_id === id) || {}).quantity || 0;
      if (was === 0) document.dispatchEvent(new CustomEvent('on:cart:add', { bubbles: true, detail: { cart, variantId: id, source: 'sample-quick' } }));
      else document.dispatchEvent(new CustomEvent('on:line-item:change', { bubbles: true, detail: { cart, variantId: id, oldQuantity: was, newQuantity: now, source: 'sample-quick' } }));
      syncFromCart(cart);
      showToast(`✓ ${label(ctl)} added${now > 1 ? ` (${now} in cart)` : ''}`);
      same(id).forEach((c) => { c.classList.remove('is-flash'); void c.offsetWidth; c.classList.add('is-flash'); clearTimeout(c._flash); c._flash = setTimeout(() => c.classList.remove('is-flash'), 1400); });
    } catch (err) {
      showToast(err.message, true);
    } finally { busy(same(id), false); }
  });
  const decOne = (ctl) => enqueue(async () => {
    const id = +ctl.dataset.variantId;
    const line = cartState.items.find((i) => i.variant_id === id);
    if (!line) { refreshCart(); return; }
    const newQty = Math.max(0, line.quantity - 1);
    busy(same(id), true);
    try {
      const cart = await post('cart/change.js', { id: line.key, quantity: newQty });
      document.dispatchEvent(new CustomEvent('on:line-item:change', { bubbles: true, detail: { cart, variantId: id, oldQuantity: line.quantity, newQuantity: newQty, source: 'sample-quick' } }));
      syncFromCart(cart);
      showToast(newQty === 0 ? `Removed ${label(ctl)}` : `${label(ctl)}: ${newQty} in cart`);
      if (newQty === 0) { const a = ctl.querySelector('[data-ss-add]'); if (a) a.focus(); }
    } catch (err) { showToast(err.message, true); refreshCart(); } finally { busy(same(id), false); }
  });

  document.addEventListener('click', (e) => {
    const t = e.target.closest('[data-ss-add],[data-ss-dec]');
    if (!t || !ours(t) || t.getAttribute('aria-disabled') === 'true') return;
    e.preventDefault(); e.stopPropagation();
    const ctl = t.closest('[data-ss-ctl]');
    if (t.matches('[data-ss-dec]')) decOne(ctl); else addOne(ctl);
  }, true);

  // Collection filters / sort / pagination re-render the grid: paint new cards from the last known cart.
  let mo;
  const watch = () => {
    if (!('MutationObserver' in window)) return;
    mo = new MutationObserver((list) => {
      if (list.some((m) => [...m.addedNodes].some((n) => n.nodeType === 1 && (n.matches('[data-sq]') || n.querySelector('[data-sq]'))))) syncFromCart(cartState);
    });
    mo.observe(document.body, { childList: true, subtree: true });
  };
  ['on:line-item:change', 'on:cart:add', 'on:cart-drawer:after-close', 'on:bfcache:load-restore'].forEach((ev) => document.addEventListener(ev, (e) => {
    if (e.detail && e.detail.source === 'sample-quick') return;
    refreshCart();
  }));
  window.addEventListener('pageshow', (e) => { if (e.persisted) refreshCart(); });
  let cartTimer;
  const cartWrite = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
  if ('PerformanceObserver' in window) {
    try {
      new PerformanceObserver((list) => {
        if (list.getEntries().some((en) => (en.initiatorType === 'fetch' || en.initiatorType === 'xmlhttprequest') && cartWrite.test(en.name.split('#')[0]))) { clearTimeout(cartTimer); cartTimer = setTimeout(() => enqueue(refreshCart), 350); }
      }).observe({ type: 'resource', buffered: false });
    } catch (e) { /* theme events + visibility refresh still apply */ }
  }
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible') refreshCart(); });
  const start = () => { if (ctls().length || document.querySelector('[data-sq]')) refreshCart(); watch(); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
